// Environment
import { EnvironmentType } from '../Enums/ChoiceEnums';

const localhostName = "localhost";
const localhostIpAddress = "127.0.0.1";

// Determine which sort of environment are we running against
export function serverEnvironment() : EnvironmentType
{
    const hostName = location.hostname.toLowerCase();
    if (hostName.startsWith("dev.") || hostName === localhostName || hostName === localhostIpAddress)
        return EnvironmentType.Dev;

    if (hostName.startsWith("qatest.") || hostName.startsWith("qa."))
        return EnvironmentType.QA;

    return EnvironmentType.Production;
}

// Indicate if we're debugging
export function areDebugging(): boolean{
    const hostName = location.hostname.toLowerCase();
    return (hostName === localhostName || hostName === localhostIpAddress);
}

// Unconditionally flag an issue
export function assertInternally(msg: string): void;
// If condition is false, msg is used to flag an issue
export function assertInternally(conditionIsGood: boolean, msg: string): void;


// Indicate there is an issue for internal development/testing
export function assertInternally(firstParam: boolean|string, secondParam?: string): void
{
    if ("string" === typeof(firstParam) && "undefined" === typeof(secondParam))
    {
        // Call the 'standard' way
        assertInternally(false, firstParam);
        return;
    }
     
    if ("boolean" !== typeof(firstParam))
        return;

    const conditionIsGood = firstParam, msg = secondParam;
    if (true === conditionIsGood)        
        return;

    const err = new Error(msg);
    console.error(err);

    switch (serverEnvironment())
    {
        case EnvironmentType.Dev:
        case EnvironmentType.QA:
        alert(msg);
        break;
    }
}